module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "connect-start"
  }, [_c('img-base64', {
    attrs: {
      "name": 'connectStart_' + _vm.controllerName
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "font-size-m text-align-center"
  }, [_vm._v(_vm._s(_vm.log))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1978de7f"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/connect/wifi/ConnectStart.vue
// module id = 870
// module chunks = 1